import { Component, OnInit , Renderer2, ElementRef, ViewChild} from '@angular/core';
import { Router } from '@angular/router';
import { Modal } from 'angular2-modal/plugins/bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';

import { EchexpaymentService } from '../echexpayment.service';
import { LocalstorageService } from '../localstorage.service';
import { UserService } from '../user.service';

@Component({
  selector: 'echexpayment-addadmin',
  templateUrl: './addechexadmin.component.html',
  styleUrls: ['./echexadmin.component.css']
})
export class AddechexadminComponent implements OnInit {
	echexAdmin: any = {};
	public token: string;
	public id: string;
    public data;
    public filterQuery = "";
    public rowsOnPage = 10;
    public sortBy = "first_name";
    public sortOrder = "asc";
	busy: Subscription;

	
	//data validation
    public val_first_name  : boolean=false;
    public val_last_name  : boolean=false;
    public val_email  : boolean=false;
	NamecharacterLimitReached: { [key: string]: boolean } = {};
	@ViewChild('submitButton') submitButton: ElementRef;

  constructor(private router: Router, public modal: Modal, private elementRef: ElementRef, private renderer: Renderer2, protected toastr: ToastrService, private userService :UserService, private echexpaymentService :EchexpaymentService, private localStorageService: LocalstorageService) { 
	let userDetails = <any>{};
	this.router = router;
	var currentUser = this.localStorageService.getData("currentUserToken");
	this.token =  currentUser.data.user_token;
	userDetails = this.localStorageService.getData("currentUser");
	this.id = userDetails._id
  }

  ngOnInit() {
	
  }
  
  ngAfterViewInit() {
    this.renderer.selectRootElement('#InitialFocus').focus();
  }

 
  moveNext(nextInput: HTMLInputElement, checkbox) {
	if(checkbox === 2){
		if (this.submitButton && this.submitButton.nativeElement) {
			this.submitButton.nativeElement.focus();
			this.submitButton.nativeElement.click();
		}
	  } else{
		nextInput && nextInput.focus();
	  }
  }
	// hide error message when input box get focus
	eventHandler(){
	  this.val_first_name = false;
	  this.val_last_name = false;
	  this.val_email = false;
	}

	// Focus Error Field
	focusFirstInvalidControlPlus(): void {
		const firstElementWithErrors: HTMLElement = this.elementRef.nativeElement.querySelector(`form .ng-invalid`);
		if (firstElementWithErrors) {
			firstElementWithErrors.focus();
		}
	}

	// Create echex Admin
	createEchexAdmin(data) {
		this.focusFirstInvalidControlPlus();   //focus field
		if(data.valid){
			let model: any = data.value;
			model.token = this.id;
			model.user_token = this.token;
			model.id = this.id;
			let responseData = <any>{};
			this.busy = this.echexpaymentService.createEchexAdmin(model).subscribe(
				response => {
				    responseData = response;
					this.toastr.success(responseData.message, 'Success!');
					this.router.navigate(['/echex-admin']);
				},
				error => {
					responseData = error;
					this.toastr.error(responseData.error.message, 'Failed!');	   
				}
			);
		}
	}

	// characters Limit check
	NameCharacterLimit(event: any, fieldName: string) {
		const maxTextLength = 25; // Maximum text length of 20 characters
		const inputChar = event.key;
		const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter'];
		const allowedKeyCodes = [46, 8, 9, 27, 13, 37, 39]; // Backspace, Delete, Tab, Escape, Enter
	  
		if (allowedKeys.indexOf(event.key) !== -1 || allowedKeyCodes.indexOf(event.keyCode) !== -1) {
		  return;
		}
	  
		const inputValue = event.target.value;
	  
		if (inputValue.length >= maxTextLength) {
		  if (allowedKeys.indexOf(inputChar) === -1) {
			this.NamecharacterLimitReached[fieldName] = true; // Set the validation flag to true to show the warning message
			setTimeout(() => {
			  this.NamecharacterLimitReached[fieldName] = false; // Hide the warning message after 3 seconds
			}, 3000);
			event.preventDefault(); // Prevent entering the exceeded character
		  }
		}
	  }
	  
	  isNameLimitReached(fieldName: string): boolean {
		return this.NamecharacterLimitReached[fieldName];
	  }
}



// WEBPACK FOOTER //
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/echexadmin/addechexadmin.component.ts